import { Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import { Link as RouterLink, useHistory } from "react-router-dom";
import useVerificationNavigation from "src/components/common/useVerificationNavigation";
import InfoIcon from "src/icons/portfolio/InfoIcon";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";
import { setPendingVerificationModal } from "src/store/features/modals.slice";
import { useUserSlice } from "src/store/features/user.slice";
import { useAppDispatch } from "src/store/store";

export const TXHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  justifyContent: "space-between",
  gap: "4px",
});

export const TXSubHeader = styled(RouterLink)({
  display: "flex",
  fontSize: "14px",
  alignItems: "center",
  gap: "8px",
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
  "&:hover": {
    opacity: 0.7,
  },
});

export const TXHeaderIcon = styled(RouterLink)({
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

export const TXMessege = styled("div")({
  display: "flex",
  height: "188px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
  alignSelf: "stretch",
});

export const TXMessegeButton = styled("button")({
  display: "flex",
  height: "25px",
  padding: "4px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
  background: "#FC4C4C",
  color: "#FFF",
  cursor: "pointer",
  textDecoration: "none",
  fontWeight: 600,
  border: "none",

  "&:hover": {
    opacity: 0.5,
  },

  "&:focus": {
    backgroundColor: "#FFF6F6",
    color: "#FC4C4C",
  },
});

const PortfolioTransactionsDefault = ({ isLoading }: { isLoading: boolean }) => {
  const { isUnverified } = useUserSlice();
  const history = useHistory();
  const { handleVerification } = useVerificationNavigation();

  const message = isUnverified
    ? "No transactions available"
    : "Start trading to view transactions here";
  const messageButton = isUnverified ? "Verify Now" : "Deposit Now";

  const handleButtonClick = () => {
    handleVerification(() => history.push("/wallets/deposit"));
  };

  if (isLoading) return <Skeleton variant="rounded" width={"100%"} height={"300px"} />;

  return (
    <>
      {/* HEADER */}
      <TXHeader>
        <TXSubHeader to="/transactions/overview">
          Your recent transactions
          <InfoIcon
            tooltip={
              "View your latest transactions here. This include deposits, trades, targets & airdrops."
            }
          />
        </TXSubHeader>
        <TXHeaderIcon to="/transactions/overview">
          <RightArrowIcon />
        </TXHeaderIcon>
      </TXHeader>

      {/* MESSEGE */}
      <TXMessege id="no-recent-transactions-message">
        {message}
        <TXMessegeButton onClick={handleButtonClick}>{messageButton}</TXMessegeButton>
      </TXMessege>
    </>
  );
};

export default PortfolioTransactionsDefault;
